import { useState, useEffect, useCallback, useRef } from 'react';

/**
 * ラベルフィルターの状態管理フック
 *
 * - displayLabels が初めて届いたタイミングで全ラベルを選択状態に初期化する
 * - isReadOnly でない場合、projectId が切り替わったらフィルターをリセットして再初期化する
 * - ユーザーがフィルターを手動変更した後は自動で再初期化しない
 */
export const useLabelFilter = (displayLabels, projectId, isReadOnly) => {
    const [filteredLabelIds, setFilteredLabelIds] = useState([]);
    const isInitialized = useRef(false);
    const prevProjectIdRef = useRef(projectId);

    // projectId 変更時（読み取り専用以外）にフィルターをリセット
    useEffect(() => {
        if (isReadOnly) return;
        if (prevProjectIdRef.current === projectId) return;

        prevProjectIdRef.current = projectId;
        isInitialized.current = false;
        setFilteredLabelIds([]);
    }, [projectId, isReadOnly]);

    // ラベルが届いたらフィルターを全選択で初期化（初回のみ）
    // filteredLabelIds.length は依存配列に含めない（ユーザー操作で再初期化を防ぐ）
    useEffect(() => {
        if (!isInitialized.current && displayLabels.length > 0) {
            setFilteredLabelIds(displayLabels.map(label => label.id));
            isInitialized.current = true;
        }
    }, [displayLabels]);

    const handleFilterChange = useCallback((newFilteredLabelIds) => {
        setFilteredLabelIds(newFilteredLabelIds);
    }, []);

    return { filteredLabelIds, setFilteredLabelIds, handleFilterChange };
};
